import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DEALS_COLORS, DEAL_TYPE_ICON, TEXT_COLOR } from 'site-modules/shared/components/deal/deal-constants';
import { PriceCheckerAnchorLink } from 'client/site-modules/shared/components/price-checker-anchor-link/price-checker-anchor-link';

import './deal-type.scss';

export function DealType({
  type = '',
  className = '',
  children = null,
  isCentered = true,
  isLabelAligned = true,
  labelClasses = '',
  isDealImgEnabled = true,
  isAnchorLink = false,
  iconClassName = 'me-0_75',
  wrapperStyle = {},
  iconStyle = {},
}) {
  const dealIconColor = DEALS_COLORS[type];

  if (!dealIconColor) return null;

  const dealEl = (
    <div
      className={classNames('d-flex scroll-link text-lowercase align-items-center text-nowrap', labelClasses, {
        [type.toLowerCase()]: isAnchorLink,
        'align-self-baseline': isLabelAligned,
      })}
      style={wrapperStyle}
    >
      <i
        className={classNames(iconClassName, 'align-middle', DEAL_TYPE_ICON[type], TEXT_COLOR[type])}
        aria-hidden
        style={iconStyle}
      />
      {type} price
    </div>
  );

  const dealImg = isAnchorLink ? <PriceCheckerAnchorLink type={type}>{dealEl}</PriceCheckerAnchorLink> : dealEl;

  return (
    <div
      className={classNames(
        'deal-type d-flex',
        { 'justify-content-center justify-content-md-end': isCentered },
        className
      )}
    >
      {isDealImgEnabled && dealImg}
      {children && <div>{children}</div>}
    </div>
  );
}

DealType.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  isCentered: PropTypes.bool,
  isLabelAligned: PropTypes.bool,
  labelClasses: PropTypes.string,
  isDealImgEnabled: PropTypes.bool,
  isAnchorLink: PropTypes.bool,
  iconClassName: PropTypes.string,
  wrapperStyle: PropTypes.shape({}),
  iconStyle: PropTypes.shape({}),
};
